import { render } from "./ProductSectionProductCreateComponent.vue?vue&type=template&id=182f17b6"
import script from "./ProductSectionProductCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionProductCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productSections/product/ProductSectionProductCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "182f17b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('182f17b6', __exports__)) {
    api.reload('182f17b6', __exports__)
  }
  
  module.hot.accept("./ProductSectionProductCreateComponent.vue?vue&type=template&id=182f17b6", () => {
    api.rerender('182f17b6', render)
  })

}


export default __exports__